
<template>
  <div class="line11">
    <img
      src="../../assets/images/tit2.png"
      style="margin-left:0;"
    >
    <a
      @click="leftClick"
      class="leftBtn"
    />
    <transition-group
      name="flip-list"
      tag="ul"
    >
      <li
        v-for="curImg in currImgs"
        :key="curImg"
      >
        <img
          :src="curImg"
          class="bannerImg"
        >
      </li>
    </transition-group>
    <a
      @click="rightClick"
      class="rightBtn"
    />
  </div>
</template>
<script>
import img1 from '../../assets/img/1.jpg'
import img2 from '../../assets/img/2.jpg'
import img3 from '../../assets/img/3.jpg'
import img4 from '../../assets/img/4.jpg'

export default {
  data () {
    return {
      currImgs: [],
      imgs: [img1, img2, img3, img4],
      index: 0
    }
  },
  mounted () {
    this.currImgs = [this.imgs[0]]
    this.startChange()
  },
  methods: {
    leftClick () {
      if (this.index <= 0) { this.index = 3 } else { this.index-- }
      this.currImgs.splice(0, 1, this.imgs[this.index])
    },
    rightClick () {
      if (this.index >= 3) { this.index = 0 } else { this.index++ }
      this.currImgs.splice(0, 1, this.imgs[this.index])
    },
    startChange () {
      var _this = this
      setInterval(function () {
        _this.rightClick()
        // _this.currImgs.splice(0, 1, _this.imgs[_this.index])
      }, 4000)
    }
  }
}
</script>

<style scoped>
.line11 {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  height:800px;
}
.line11 .bannerImg{
    max-width: inherit;
    position:absolute;
    right: 0;
    top:50px;
}
.line11 .rightBtn {
    position: absolute;
    width: 42px;
    height: 85px;
    right: -10%;
    top: 338px;
    background: url(../../assets/img/ybtn.png) no-repeat;
    z-index: 999;
}

.line11 .leftBtn {
    position: absolute;
    width: 42px;
    height: 85px;
    left: -10%;
    top: 338px;
    background: url(../../assets/img/zbtn.png) no-repeat;
    z-index: 999;
}
.line11 a{
    cursor: pointer;
}
.flip-list-enter-active, .flip-list-leave-active {
            transition: all 1s;
        }
        .flip-list-enter, .flip-list-leave-active {
            opacity: 0;
        }
</style>



// WEBPACK FOOTER //
// src/components/index/line11.vue